export function wpcf7Handler() {
    // 1
    document.addEventListener("wpcf7invalid", function (event) {
        // alert("invalid");
    }, false);

    // 2
    document.addEventListener("wpcf7submit", function (event) {
        // alert("submit");

        let $form = $(this);
        let $formItems = $form.find(".form-item");

        $formItems.each((index, item) => {
            let $item = $(item);

            if ($item.find(".wpcf7-not-valid-tip").length) {
                $item.addClass("invalid-field");
            } else {
                $item.removeClass("invalid-field");
            }
        });
    }, false);

    document.addEventListener("wpcf7mailfailed", function (event) {
        // alert("mailfailed");
    }, false);

    document.addEventListener("wpcf7mailsent", function (event) {
        // alert("mailsent");
        jcf.destroyAll();
        jcf.replaceAll();
    }, false);
}


// WEBPACK FOOTER //
// ./assets/js/modules/wpcf7-handler.js